"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPACING = exports.SHADES_AND_DETAILS_SHADE = exports.SHADES_AND_DETAILS_CAROUSEL = exports.SHADES_AND_DETAILS = void 0;
const SHADES_AND_DETAILS = exports.SHADES_AND_DETAILS = 'shades-and-details';
const SHADES_AND_DETAILS_CAROUSEL = exports.SHADES_AND_DETAILS_CAROUSEL = 'shades-and-details-carousel';
const SHADES_AND_DETAILS_SHADE = exports.SHADES_AND_DETAILS_SHADE = 'shades-and-details-shade';
const SPACING = exports.SPACING = 5;
